function initErrors() {
	return {
		hasError: false,
		errors: {}
	};
}

function addError(errors, context, id, data) {
	if(errors.errors[context? context:"_global"] === undefined) {
		errors.errors[context ? context : "_global"] = {id, data};
	}
	else {
		if(!Array.isArray(errors.errors[context? context:"_global"])) {
			errors.errors[context? context:"_global"] = [errors.errors[context? context:"_global"]];
		}
		(errors.errors[context? context:"_global"]).push({id, data});
	}
	errors.hasError = true;
}

function errorResult(errors) {
	if(errors.hasError) {
		return errors.errors;
	}
	else {
		return null;
	}
}

export function serverErrorsToLocalErrors(errors) {
	const err = initErrors();
	if(errors) {
		for (const error of errors) {
			addError(err, error.context ? error.context : null, error.id ? error.id : "unknown", error.data);
		}
	}
	return errorResult(err);
}
